import { ContactForm } from './ContactForm'

export function FugueContactForm() {
  return (
    <ContactForm
      header="Ready to Modernize Your Festival?"
      body="Tell us about your festival, your digital challenges, and what you're hoping to achieve. We'll get back to you within 24 hours to discuss how we can help grow your enrollment and streamline your operations."
      calendlyUrl="https://calendly.com/garrett-garrettjohnlaw/30min"
      calendlyHeading="Prefer a call? Book a free 15-minute call."
    />
  )
}
